import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Dropdown, Loader } from 'semantic-ui-react';

import { useSkills } from '../../hooks/skills';
import { SkillsService } from '../../services/methods/SkillsService';

import {
  Container,
  AddColor,
  Input,
  Results,
  ResultsUl,
  ResultsLi} from './styles';

interface Props {
  type: 'skill' | 'product' | 'module';
  color: string;
  code?: string;
}

interface IOptions {
  codigo: string;
  tipo: "1" | "2" | "3";
  nome: string;
  codpai: string;
}

const AddSkill: React.FC<Props> = ({ color, type, code }) => {
  const skillsService: SkillsService = new SkillsService();

  const [isLoading, setIsLoading] = useState(false)
  const [item, setItem] = useState('')
  const [itens, setItens] = useState<IOptions[]>([])
  const [itensList, setItensList] = useState<IOptions[]>([])
  const [openItens, setOpenItens] = useState(false)

  const { handleAddNewSkill } = useSkills()

  function getTitle(type: 'skill' | 'product' | 'module') {
    if (type === 'skill') return '+ Adicionar Skill'
    if (type === 'product') return '+ Adicionar Produto'
    if (type === 'module') return '+ Adicionar Módulo'
  }

  async function getOptions(type: 'skill' | 'product' | 'module') {
    setIsLoading(true)
    const token = await sessionStorage.getItem('token')
    try {
      if (type === 'product') {
        const { data } = await skillsService.getProductSearch(token)

        if (data.status === 'ok') {

          setItens(data.dados)
          setItensList(data.dados)
        } else {
          toast.error(data.msg)
        }
      } else if (type === 'module') {
        const { data } = await skillsService.getGroupsSearch(token, code!)

        if (data.status === 'ok') {

          setItens(data.dados)
          setItensList(data.dados)
        } else {
          toast.error(data.msg)
        }
      } else if (type === 'skill') {
        const { data } = await skillsService.getSkillSearch(token, code!)

        if (data.status === 'ok') {

          setItens(data.dados)
          setItensList(data.dados)
        } else {
          toast.error(data.msg)
        }
      } else {
        toast.error('Ops... algo deu errado!')
      }
      setOpenItens(true)

    } catch (error: any) {
      setOpenItens(false)
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const itensArr = itens.filter((value) => value.nome.toLowerCase().includes(item.toLowerCase()))

    setItensList(itensArr)
  }, [item])

  // useEffect(() => {
  //   getOptions(type)
  // }, [])

  return (
    <Dropdown
      id="skillDropdown"
      placeholder={getTitle(type)}
      style={{ marginTop: type === 'product' ? '0px' : '16px', borderRadius: type === 'skill' ? '10px' : '20px' }}
      noResultsMessage={ isLoading ? "Carregnado..." : "Nenhum produto encontrado"}
      fluid
      search
      selection
      selectOnBlur={false}
      value={item}
      onChange={(event, data) => { itensList.find(item => item.codigo === data.value) && handleAddNewSkill(itensList.find(item => item.codigo === data.value)!, type) }}
      loading={isLoading}
      onFocus={() => getOptions(type)}
      options={isLoading ? [] : itensList.map(item => { return { key: item.codigo, value: item.codigo, text: item.nome } })}
    />
    // <Container tipo={type}>
    //   <AddColor tipo={type} style={{ backgroundColor: color }} />

    //   {/* <Input
    //     tipo={type}
    //     type="text"
    //     value={item}
    //     onBlur={() => setTimeout(function () { setOpenItens(false); }, 300)}
    //     onFocus={() => getOptions(type)}
    //     onChange={e => setItem(e.target.value)}
    //     placeholder={getTitle(type)}
    //   />
    //   {isLoading && <Loader active inline='centered'>Carregando</Loader>}

    //   {openItens &&
    //     <Results tipo={type}>

    //       <ResultsUl>
    //         {itensList.map(item => (
    //           <ResultsLi
    //             key={item.codigo}
    //             onClick={() => handleAddNewSkill(item, type)}
    //             tipo={type}
    //           >
    //             {item.nome}
    //           </ResultsLi>
    //         ))}
    //       </ResultsUl>
    //     </Results>
    //   } */}
    // </Container>
  );
}

export default AddSkill;